<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import PartnerDetailPage from '~/features/revalidaCampaigns/pages/partner-detail.vue';

const route = useRoute();
const id = computed(() => String((route.params as { id: string }).id));
</script>

<template>
  <PartnerDetailPage :id="id" />
</template>
